var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoClose1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6123 17.6113L9.22461 9.99902L1.6123 17.6113ZM16.8369 2.38672L9.22461 9.99902L16.8369 2.38672ZM9.22461 9.99902L1.6123 2.38672L9.22461 9.99902ZM9.22461 9.99902L16.8369 17.6113L9.22461 9.99902Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6123 17.6113L9.22461 9.99902M9.22461 9.99902L16.8369 2.38672M9.22461 9.99902L1.6123 2.38672M9.22461 9.99902L16.8369 17.6113",
    stroke: "#575757",
    strokeWidth: 2.23559,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClose1);
export default __webpack_public_path__ + "static/media/ico-close1.15a531e3fc4593d0bcba8a99d392b54e.svg";
export { ForwardRef as ReactComponent };